export const getMatterIdPropertyName = () => "Smokeball.MatterId";
export const getRegionPropertyName = () => "Smokeball.Region";
export const getEnvPropertyName = () => "Smokeball.Env";

const getMailItemProperty = async (
  mailItem: Office.MessageRead | Office.MessageCompose,
  propertyName: string
): Promise<string | null> => {
  try {
    const result = await new Promise<Office.AsyncResult<Office.CustomProperties>>((resolve) => {
      mailItem.loadCustomPropertiesAsync((result) => {
        resolve(result);
      });
    });

    if (result.status === Office.AsyncResultStatus.Succeeded) {
      const value = result.value.get(propertyName);

      if (value === undefined || value === null) {
        console.info(`Mail Box Item property: (${propertyName}) was undefined or null.`);
        return null;
      }

      console.info(`Mail Box Item property: (${propertyName}) value was found: ${value}.`);
      return value;
    }

    console.error(`Failed to retrieve Mail Box Item property: (${propertyName}). Status: ${result.status}`);
    return null;
  } catch (error) {
    console.error(`Error retrieving Mail Box Item property: (${propertyName}). Error: ${error}`);
    return null;
  }
};

const setMailItemProperty = async (
  mailItem: Office.MessageRead | Office.MessageCompose,
  propertyName: string,
  propertyValue: string | null
): Promise<boolean> => {
  try {
    const result = await new Promise<Office.AsyncResult<Office.CustomProperties>>((resolve) => {
      mailItem.loadCustomPropertiesAsync((result) => {
        resolve(result);
      });
    });

    if (result.status === Office.AsyncResultStatus.Succeeded) {
      console.log("Loaded custom property", JSON.stringify(result.value));
      if (propertyValue == null) {
        console.log("Removing custom property", propertyName);
        result.value.remove(propertyName);
      } else {
        console.log("Adding custom property", propertyName, propertyValue);
        result.value.set(propertyName, propertyValue);
      }

      console.log("Saving custom property", JSON.stringify(result.value));
      await new Promise((res, rej) => {
        result.value.saveAsync((asyncRes) => {
          if (asyncRes.status === Office.AsyncResultStatus.Failed) {
            rej(asyncRes.error);
          } else {
            res(asyncRes.value);
          }
        });
      });

      console.log("Saved custom property");
      return true;
    }

    console.error(
      `Failed to save Mail Box Item property: (${propertyName}). Status: ${result.status}. Value: ${propertyValue}`
    );
    return false;
  } catch (error) {
    console.error(
      `Error retrieving Mail Box Item property: (${propertyName}). . Value: ${propertyValue}. Error: ${error}`
    );
    return false;
  }
};

export const getComposeMailItemId = async (composeItem: Office.MessageCompose): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (!composeItem) {
      return resolve("");
    }

    composeItem.getItemIdAsync((result) => {
      if (result.status === Office.AsyncResultStatus.Failed) {
        console.error(`getItemIdAsync failed: ${result.error.message}`);
        reject(result.error);
      } else {
        resolve(result.value ?? "");
      }
    });
  });
};

export const getMailboxService = () => ({
  getMailItemProperty,
  setMailItemProperty,
  getComposeMailItemId,
});
